import {Form, Select} from "antd";
import React from "react";

let selectVals = (value, label) => ({ value, label })

export default ({notRequired, name, label, options, onChange, width, disabled, itemProps={},...props}) => <Form.Item name={name} label={label} rules={[{ required: !notRequired, message: "Required" }]} {...itemProps}>
  <Select disabled={disabled} onChange={onChange} style={{width: width || "100%"}} options={options.map(o => selectVals(o[0], o[1]))} {...props}/>
</Form.Item>
